<template>
  <div id="app" :class="{'show-tab-bar':$store.state.tabBarShow}">
  	<!--<transition name="fade">-->
    	<download-header v-if="showDownloadHeader==1" @close="closeDownloadHeader()"></download-header>
    <!--</transition>-->
    <router-view></router-view>
    <mt-tabbar fixed v-model="$store.state.tabChoosed" v-if="$store.state.tabBarShow">
		  <mt-tab-item id="home" @click.native="changeHash('home')">
		    <img class="icon-default" slot="icon" src="./assets/img/menu-bar/btn_tab_home_default@2x.png">
		    <img class="icon-active" slot="icon" src="./assets/img/menu-bar/btn_tab_home_pressed@2x.png">首页
		  </mt-tab-item>
		  <mt-tab-item id="trends" @click.native="changeHash('trends')">
		    <img class="icon-default" slot="icon" src="./assets/img/menu-bar/btn_tab_dongtai_default@2x.png">
		    <img class="icon-active" slot="icon" src="./assets/img/menu-bar/btn_tab_dongtai_pressed@2x.png">动态
		  </mt-tab-item>
		  <mt-tab-item id="chats" @click.native="changeHash('friend-list')">
		    <img class="icon-default" slot="icon" src="./assets/img/menu-bar/btn_tab_chat_default@2x.png">
		    <img class="icon-active"  slot="icon" src="./assets/img/menu-bar/btn_tab_chat_pressed@2x.png">好友
		  </mt-tab-item>
		  <mt-tab-item id="finds" @click.native="changeHash('finds')">
		    <img class="icon-default" slot="icon" src="./assets/img/menu-bar/btn_tab_faxian_default@2x.png">
		    <img class="icon-active" slot="icon" src="./assets/img/menu-bar/btn_tab_faxian_pressed@2x.png">发现
		  </mt-tab-item>
		  <mt-tab-item id="mine" @click.native="changeHash('mine')">
		    <img class="icon-default" slot="icon" src="./assets/img/menu-bar/btn_tab_wode_default@2x.png">
		    <img class="icon-active" slot="icon" src="./assets/img/menu-bar/btn_tab_wode_pressed@2x.png">我的
		  </mt-tab-item>
		</mt-tabbar>
		
		<get-position @getPosition="getPosition"></get-position>
  </div>
</template>

<script>


	import GetPosition from '@/components/Common/GetPosition'
	import DownloadHeader from '@/components/Common/DownloadHeader'
	
export default {
  name: 'App',
  components:{
			GetPosition,
			DownloadHeader
		},
  data(){
  	return{
  		showDownloadHeader:1,
  	}
  },
  computed:{
		
  },
  created(){
  	this.isLogin();
  	console.log(document.cookie)
//		console.log(this.$store.state.AdminInfo);
		this.$axios({
			url:"Currency/UserInformation",
			method:"post",
			data:{
				uid:this.$store.state.UserId
			}
		}).then(res=>{
//			console.log(res);
			if(res.data.code==200){
				this.$store.commit("getAdminInfo", res.data.data);
			}else{
				this.$store.commit("getAdminInfo", "未登录");
			}
				console.log(this.$store.state.AdminInfo)
		}).catch(err=>{
			console.log(err);
			this.$indicator.close();
			this.$toast({
				message:"加载超时，请重试",
				position:"bottom",
				duration:3000
			})
		})
  },
  methods:{
  	getPosition(data){
//				console.log(data);
				this.$store.commit("setNowAdd", data.name);
			},
  	changeHash:function(id){
  		this.$router.push({
  			name:id
  		})
  	},
  	closeDownloadHeader(){
  		this.showDownloadHeader = 0;
  	}
  },
  watch:{
	selected(newV,oldV){ 
		this.$router.push({
			name:newV
		})
	}
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue